export default {"src":"/_next/static/media/CNQ.f71f023e.svg","height":18,"width":18};